import React, { useEffect } from 'react';
import Page404 from '../../components/404';
import { useDispatch } from 'react-redux';
import { updateWording } from '../../store/actions';

export default function NotFoundPage() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(updateWording());
    });

    return <Page404 />;
}
